/* YUDI — theme.js
   Vanilla, no build step, no framework. Progressive enhancement only:
   every navigable thing here works as a plain link with JS disabled. */

(function () {
  'use strict';

  /* ---- Mobile navigation drawer ------------------------------------------
     The drawer is a plain <nav> that is visible at desktop widths and toggled
     below 900px. Focus is trapped while it is open and returned to the
     trigger on close. */

  function initNavDrawer() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;

    var close = drawer.querySelector('[data-nav-close]');
    var lastFocused = null;

    function focusables() {
      return drawer.querySelectorAll('a[href], button:not([disabled])');
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = focusables()[0];
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function shut() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        shut();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', function () {
      if (drawer.hidden) open(); else shut();
    });

    if (close) close.addEventListener('click', shut);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavDrawer);
  } else {
    initNavDrawer();
  }
})();

/* ---- Storefront filters -------------------------------------------------
   Ticking a filter submits the form immediately when JS is available. The
   apply button stays in the markup for the no-JS case and is hidden here. */

(function () {
  'use strict';

  function initFacets() {
    var form = document.querySelector('[data-facets]');
    if (!form) return;

    var apply = form.querySelector('[data-facets-apply]');
    if (apply) apply.hidden = true;

    form.addEventListener('change', function (event) {
      if (event.target.type === 'checkbox') form.submit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacets);
  } else {
    initFacets();
  }
})();
